import { baseApi } from '@/services'
import { Snapshot } from '@/types/unlock'

export const snapshotApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSnapshots: builder.query<Snapshot[], any>({
      query: (params) => {
        const searchParams = new URLSearchParams()

        Object.keys(params).forEach((key) => {
          if (params[key] !== undefined) searchParams.append(key, params[key])
        })

        return `v2/snapshot/?${searchParams.toString()}`
      },
      providesTags: ['Snapshot'],
    }),
    createSnapshot: builder.mutation<Snapshot, Partial<Snapshot>>({
      query: (body: Partial<Snapshot>) => ({
        method: 'POST',
        url: 'v2/snapshot/',
        body,
      }),
      invalidatesTags: ['Snapshot', 'Application'],
    }),
    updateSnapshot: builder.mutation<Snapshot, Partial<Snapshot>>({
      query: (body: Partial<Snapshot>) => ({
        method: 'PATCH',
        url: `v2/snapshot/${body.uuid}/`,
        body,
      }),
    }),
  }),
})

export const { useGetSnapshotsQuery, useCreateSnapshotMutation, useUpdateSnapshotMutation } =
  snapshotApi
